import React, { useLayoutEffect, useState } from 'react';
import Icon from '../../atoms/Icon';
import theme from '../../theme';
import { IconWrapper } from './style';

const Scroller = () => {
  const [showButton, setShowButton] = useState(false);
  const [element, setElement] = useState();

  useLayoutEffect(() => {
    function checkScroll() {
      if (window.scrollY > 250) setShowButton(true);
      else setShowButton(false);
    }

    window.addEventListener('scroll', checkScroll);
    checkScroll();
    const anchor = document.querySelector('#anchor');
    setElement(anchor);

    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  return (
    <IconWrapper
      onClick={() => {
        window.scrollTo({
          top: element.offsetTop - 150,
          behavior: 'smooth',
        });
      }}
      showButton={showButton}
    >
      <Icon type="arrow-narrow-up" size={18} stroke={theme().colors.link} />
    </IconWrapper>
  );
};

export default Scroller;
